import React, { useCallback } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from '../..';
import { CogIcon } from '../../icon/solid';
import { StudioControlStyles } from '../styles';
import StudioToolTip from './StudioToolTip';
import { selectIsOpenSettingsPanel } from '../../../store/modules/studio/selectors';
import { setOpenSettingsPanel } from '../../../store/modules/studio/actions';

const SettingAction = () => {
  const classes = StudioControlStyles();
  const dispatch = useDispatch();
  const isOpenSettingsPanel = useSelector(selectIsOpenSettingsPanel);

  const togglePanel = useCallback(() => {
    dispatch(setOpenSettingsPanel(!isOpenSettingsPanel));
  }, [dispatch, isOpenSettingsPanel]);

  return (
    <StudioToolTip title="Open and close the settings panel">
      <Button
        onClick={togglePanel}
        className={clsx(
          classes.button,
          classes.circleButton,
          isOpenSettingsPanel ? classes.activeButton : '',
        )}
        classes={{
          label: classes.circleButton,
        }}
        data-intercom-target="Button: Settings"
      >
        <CogIcon className={classes.icon} />
      </Button>
    </StudioToolTip>
  );
};

export default SettingAction;
